import { render, staticRenderFns } from "./MiddleUser.vue?vue&type=template&id=82037738&scoped=true&"
import script from "./MiddleUser.vue?vue&type=script&lang=js&"
export * from "./MiddleUser.vue?vue&type=script&lang=js&"
import style0 from "./MiddleUser.vue?vue&type=style&index=0&id=82037738&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82037738",
  null
  
)

export default component.exports